import getCountryCode from '../../basic/getCountryCode';

export interface IGetMTCCClientOptions {
    gid: string;
    functionInfo: {
        name: string;
        [k: string]: any;
    };
    payInfo?: {
        /**
         * 订阅中台的订单ID
         */
        pay_order_id?: string;
        /**
         * 没有拿到订阅中台pay_order_id情况下上报
         */
        transfer_id?: string;
        /**
         * 没有走订阅中台的订单，上报业务侧的订单ID
         */
        biz_order_id?: string;
        /**
         * 代币、美豆消耗ID
         */
        out_trade_no?: string;
        [k: string]: any;
    };
    positionInfo: {
        level1: string;
        [k: string]: any;
    };
    /**
     * 是否是toB项目，目前项目分为两种toB/toC
     */
    isToB: boolean;
    virtualId: string;
    uid?: number;
    osType: string;
    app_id?: string;
    /**
     * 是否为团队版场景
     */
    isTeam?: boolean;
    /**
     * 是否为海外版starii，如果没传则默认读取window.isIntl变量
     */
    isIntl?: boolean;
    /**
     * 是否为pc内嵌
     */
    isPcPlatform?: boolean;
    /**
     * 上传的媒体格式
     * text/photo/video
     */
    mediaType: string;
    /**
     * 目标生成的媒体格式
     */
    resMediaType: string;
    /**
     * 本次任务的媒体数量（按需上报，未传则不进入上报体）
     */
    number?: number;
    /**
     * 本次任务的媒体时长，单位由业务约定（按需上报，未传则不进入上报体）
     */
    duration?: number;
    /**
     * 业务ID，秀秀内嵌设计室才需要报，美图设计室app不用报
     */
    biz_id?: string;
    /**
     * 是否为WPS web
     */
    isWPSWeb?: boolean;
    /**
     * 是否为WPS pc内嵌
     */
    isWPSPc?: boolean;
}

/**
 * 获取云储存分摊埋点透传值
 * @param options
 * @returns
 */
const getMTCCClient = async (options: IGetMTCCClientOptions) => {
    const {
        gid,
        functionInfo,
        positionInfo,
        isToB,
        virtualId,
        uid,
        osType,
        app_id,
        isIntl,
        isTeam,
        isPcPlatform,
        mediaType,
        resMediaType,
        number,
        duration,
        biz_id,
        isWPSWeb,
        isWPSPc,
        payInfo,
    } = options;

    const country_code = await getCountryCode();

    let appId = '';
    if (app_id) {
        // 业务自定义
        appId = app_id;
    } else if (isPcPlatform) {
        // pc内嵌下
        appId = '8045';
    } else if (isIntl || window.isIntl) {
        // designKit 全球化 / 海外 x-design
        appId = window.deployApp === 'designkit' ? '227' : '2000010';
    } else {
        // web国内
        appId = '178';
    }

    let bizType = '';
    if (isTeam) {
        bizType = 'team';
    } else if (isToB) {
        bizType = 'api';
    } else if (isWPSWeb) {
        bizType = 'wps_web';
    } else if (isWPSPc) {
        bizType = 'wps_pc';
    }

    return btoa(
        JSON.stringify({
            app_id: appId,
            biz_id: biz_id || '',
            os_type: osType,
            country_code,
            gnum: gid,
            function: functionInfo,
            position: positionInfo,
            media_type: mediaType,
            res_media_type: resMediaType,
            // number / duration 为按需上报字段，仅在业务显式传入时进入上报体，避免影响未使用的调用方
            ...(number !== undefined ? { number } : {}),
            ...(duration !== undefined ? { duration } : {}),
            ext_info: {
                biz_type: bizType,
                virtual_id: virtualId,
                pay_info: payInfo || {},
            },
            uid: uid || '',
        }),
    );
};

export default getMTCCClient;
